import { useCallback } from 'react';
import { gql } from 'apollo-boost';
import { useMutation } from 'shared/apollo';

export const newServiceCollection = gql`
  mutation newServiceCollection(
      $name: String!
      $description: String!
      $serviceIds: String!
      $donorIds: String
      $portfolioIds: String
      ) {
    newCollection(
        name: $name
        description: $description
        serviceIds: $serviceIds
        donorIds: $donorIds
        portfolioIds: $portfolioIds
      ) {
      success
      id
    }
  }
`;

export function useNewServiceCollection() {
  const { data, isLoading, mutate } = useMutation();
  const run = useCallback((variables, onFinish) => {
    mutate(newServiceCollection, variables, response => {
      if (typeof onFinish === 'function') {
        onFinish(response.newCollection.id);
      }
    });
  }, []);
  return { data, isLoading, run };
}
